<template lang="pug">
  GlobalWrapper
    nuxt
</template>

<script>
import GlobalWrapper from '../components/GlobalWrapper'

export default {
  components: { GlobalWrapper },
}
</script>
